/* eslint-disable @typescript-eslint/ban-ts-comment */
/* eslint-disable react-hooks/exhaustive-deps,
@typescript-eslint/no-unsafe-assignment,
@typescript-eslint/no-unsafe-call */
import {
  Box,
  Flex,
  Image,
  Tab,
  TabList,
  Tabs,
  useBreakpointValue,
} from '@chakra-ui/react';
import { Analytics } from 'cliengo-fe-utils';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { useLocation, useNavigate } from 'react-router-dom';

import Show from '@/components/show';
import { CLIENT_MANAGER_ROUTES } from '@/constants/routes';
import useIframe from '@/hooks/useIframe';
import { events } from '@/utils/segment/events';

/**
 * Main Navbar of the application
 * Contains Tabs for navigating to applications pages
 * @see https://chakra-templates.dev/navigation/navbar
 * @see https://chakra-ui.com/docs/components/tabs#controlled-tabs
 */
export const Navbar = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useTranslation();
  const { inIframe } = useIframe();

  const routes: string[] = [
    CLIENT_MANAGER_ROUTES.messages,
    CLIENT_MANAGER_ROUTES.templates,
    CLIENT_MANAGER_ROUTES.contactLists,
    CLIENT_MANAGER_ROUTES.blacklist,
  ];

  const [tabIndex, setTabIndex] = useState(() => {
    const index = routes.findIndex((route) =>
      location.pathname.includes(route)
    );

    return index < 0 ? 0 : index;
  });

  const navigateToIndex = (index: number) => {
    setTabIndex(index);
    navigate(routes[index]);
    Analytics.trackEvent(events.manager.layout.navbar.tabs[index]);
  };

  const logoUrl = useBreakpointValue({
    base: 'https://res.cloudinary.com/hbrrdozyj/image/upload/v1708718572/cliengo-static/cliengo128.svg',
    lg: 'https://res.cloudinary.com/hbrrdozyj/image/upload/v1558546804/cliengo819x195_zxegqs.png',
  });

  return (
    <Box
      borderBottom={1}
      borderStyle={'solid'}
      borderColor={'gray.200'}
      shadow={'lg'}
      py={'0.5'}
      width={'100%'}
    >
      <Flex align={'center'} px="24px" justify={'space-between'}>
        <Flex flex={1} display={'flex'} justifyContent={'flex-start'}>
          <Tabs
            variant={'soft-rounded'}
            colorScheme={'primary'}
            index={tabIndex}
            onChange={navigateToIndex}
          >
            <TabList>
              <div id="messages-tab">
                <Tab>{t('manager.layout.navbar.tabs.messages')}</Tab>
              </div>

              <div id="templates-tab">
                <Tab>{t('manager.layout.navbar.tabs.templates')}</Tab>
              </div>

              <div id="contact-lists-tab">
                <Tab>{t('manager.layout.navbar.tabs.contact_list')}</Tab>
              </div>
              <Tab>{t('manager.layout.navbar.tabs.blocked_numbers')}</Tab>
            </TabList>
          </Tabs>
        </Flex>

        <Show when={!inIframe}>
          <Flex my={3} h={'30px'}>
            <Image fit={'contain'} src={logoUrl} />
          </Flex>
        </Show>
      </Flex>
    </Box>
  );
};
